import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Navigate, useLocation } from "react-router-dom";
import { Radar } from "lucide-react";
import api from "@/lib/api";

const BILLING_FREE = ["/app/billing/"];

export function ProtectedRoute({ children, adminOnly = false }) {
  const { user } = useAuth();
  const location = useLocation();
  const [access, setAccess] = useState(null);
  useEffect(() => {
    if (!user) return;
    if (user.role === "admin") { setAccess(true); return; }
    api.get("/subscription").then((r) => setAccess(!!r.data.access_allowed)).catch(() => setAccess(true));
  }, [user, location.pathname]);
  if (user === null || (user && access === null && !BILLING_FREE.some((p) => location.pathname.startsWith(p)))) {
    return (
      <div className="min-h-screen grid place-items-center bg-slate-50">
        <Radar className="w-8 h-8 text-blue-600 animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/app/dashboard" replace />;
  if (access === false && !BILLING_FREE.some((p) => location.pathname.startsWith(p))) return <Navigate to="/app/billing/pending" replace />;
  return children;
}
